<div class="modal-header d-flex justify-content-between align-items-center">
  <h4 class="modal-title flex-grow-1 text-center">Introducing TXdocs Editor</h4>
  <button type="button" class="btn-close-circle" (click)="closeDialog()">X</button>
</div>
<div class="modal-body">
  <h5 class="text-center">More than just a word processor</h5>
  <div class="grid">
    <div class="g-col-6">
      <p>See what makes TXdocs Editor different.</p>
      <div class="d-flex align-items-center">
        <a href="https://vimeo.com/995883429" target="_blank" class="btn btn-intro-dialog d-flex align-items-center me-2">
            <span class="icon-circle">
                <i class="bi bi-camera-video-fill"></i>
            </span>
            <span class="button-text">Intro video</span>
        </a>
        <a href="https://vimeo.com/963506870" target="_blank" class="btn btn-intro-dialog d-flex align-items-center">
            <span class="icon-circle">
                <i class="bi bi-camera-video-fill"></i>
            </span>
            <span class="button-text">Tutorial video</span>
        </a>
      </div>
    </div>
    <div class="g-col-6">
      <p>Change the default look of all your assembled documents.</p>
      <div class="d-flex justify-content-center align-items-center">
        <a href="https://vimeo.com/995883451" target="_blank" class="btn btn-intro-dialog d-flex align-items-center">
            <span class="icon-circle">
                <i class="bi bi-camera-video-fill"></i>
            </span>
            <span class="button-text">Learn more</span>
        </a>
      </div>
    </div>
  </div>
  <div class="form-check">
    <input class="form-check-input" type="checkbox" id="dontShowAgain" name="dontShowAgain" (change)="onDontShowAgainChanged($event)" />
    <label class="form-check-label" for="dontShowAgain">
      Don't show this again
    </label>
  </div>
</div>
